import { ethers } from "ethers";
import {
  nils,
  iso,
  nano,
  tofeth,
  toeth,
  blocktime_iso,
  base64_to_json,
} from "../../utils/utils.jsx";
import _ from "lodash";
import abi from "./abis/PrizeBoxOpener.json";
import { CV2_Contract } from "./cv2_base.js";
import { contractAddress_list } from "../contracts.jsx";

class Contract extends CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    super({ contract_k, contractAddress, aumode, abi, ...ext });
  }

  async getParsedLogs(logs) {
    if (!logs) return [];

    let logrows = [];
    for (let log of logs) {
      let iface = new ethers.Interface(this.abi);
      let par = iface.parseLog(log);

      if (nils(par)) continue;

      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;

      // event OpenLootboxEventOptions(bytes32 payid, address vault, uint qty, uint boxtype, string encoded);

      if (name == "OpenLootboxEventOptions") {
        let a = par.args;

        let encoded = a[4];
        encoded = base64_to_json(encoded);
        o.args = {
          payid: a[0],
          vault: a[1].toLowerCase(),
          qty: Number(a[2]),
          boxtype: Number(a[3]),
          encoded,
        };
      }

      logrows.push(o);
    }
    return logrows;
  }

  async burnLootbox_wOptions(qty, boxtype, encoded, info = {}) {
    let tx = await this.run(
      "burnLootbox_wOptions",
      [qty, boxtype, encoded],
      info,
    );
    return tx;
  }
}

const k = "prizeboxopener";

const get_contract_address = () => {
  return contractAddress_list.prizebox_opener;
};

const get_contract = async (ext = {}) => {
  const contractAddress = get_contract_address();
  const runner = new Contract({
    contract_k: k,
    contractAddress,
    aumode: ext.aumode || "thirdweb",
    abi,
    ...ext,
  });
  return runner;
};

const PrizeBoxOpener = {
  k,
  get_contract,
  get_contract_address,
};

export default PrizeBoxOpener;
